/**
 * Popup Modal System for Book Tour and Enquiry Forms
 * Replaces the old content hiding system with proper popup modals
 */

$(function() {
    
    // AGGRESSIVE OVERRIDE: Remove all old event handlers immediately
    $(document).off('click', 'a.js-book-tour-btn');
    $(document).off('click', 'a.js-enrolment-enquiry-btn');
    $('a.js-book-tour-btn').off('click');
    $('a.js-enrolment-enquiry-btn').off('click');
    
    // Override any existing modal functions
    if (typeof window.openTourModal === 'function') {
        window.openTourModal = function() {
            return;
        };
    }
    
    if (typeof window.openEnquiryModal === 'function') {
        window.openEnquiryModal = function() {
            return;
        };
    }
    
    // Popup Modal System
    var PopupModal = {
        // Open popup modal
        open: function(modalId, options = {}) {
            var $modal = $(modalId);
            if (!$modal.length) {
                return;
            }
            
            // Default settings
            var settings = $.extend({
                scrollToTop: true,
                analytics: true,
                historyStep: 1
            }, options);

            // Add overlay if it doesn't exist
            if (!$('#popup-overlay').length) {
                $('body').append('<div id="popup-overlay" class="popup-overlay"></div>');
            }

            // Ensure modal is hidden first
            $modal.hide();
            
            // Show overlay and modal
            
            // Add close button if it doesn't exist
            if (!$modal.find('.js-modal-close-btn').length) {
                var closeBtn = $('<button class="js-modal-close-btn" aria-label="Close modal">×</button>');
                var completeBtn = $('.js-tour-complete');
                var reviewTrigger = $('.rpi-info a');
                var backBtn = $('.back-btn');
                $modal.prepend(closeBtn);
                
                // Attach click handler directly to the new button
                closeBtn.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    PopupModal.closeAll();
                    return false;
                });

                backBtn.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    PopupModal.closeAll();
                    return false;
                });

                completeBtn.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    PopupModal.closeAll();
                    return false;
                });

                reviewTrigger.on('click', function(e) {
                    e.stopPropagation();
                    PopupModal.closeAll();
                    return false;
                });
            }
            
            
            // Add popup-modal class to the modal
            $modal.addClass('popup-modal');
            
            // Force modal to be visible with inline styles
            $modal.css({
                'display': 'block',
                'position': 'fixed',
                'top': '50%',
                'left': '50%',
                'transform': 'translate(-50%, -50%)',
                'z-index': '9999',
                'background': 'white',
                'border-radius': '8px',
                'box-shadow': '0 10px 30px rgba(0, 0, 0, 0.3)',
                'max-width': '90%',
                'max-height': '90%',
                'overflow-y': 'auto'
            });
            
            $('#popup-overlay').fadeIn(300);
            $modal.fadeIn(500);

            // Scroll to top if requested. The Centre Page shell is wrapped in
            // an IIFE, so legacy helpers such as `to_top` are not globals here.
            if (settings.scrollToTop) {
                if (typeof window.to_top === 'function') {
                    window.to_top();
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 800);
                }
            }

            // Add modal-open class to body
            $('body').addClass('modal-open');

            // Analytics tracking. Modal-specific handlers below are the single
            // source of open events; form initialisers only prepare the form.
            if (settings.analytics) {
                var isTourModal = $modal.is('#book-tour-modal');
                var centreId = $modal.data("centre-id") || "";

                if (typeof hj !== "undefined") {
                    hj("trigger", isTourModal ? "book_tour" : "enrolment_enq");
                }

                if (typeof window.GA_Send_Event === 'function') {
                    window.GA_Send_Event(
                        isTourModal ? "book-tour-modal" : "enquiry-modal",
                        "open",
                        centreId
                    );
                } else if (typeof window.ga === 'function') {
                    window.ga(
                        "send",
                        "event",
                        isTourModal ? "book-tour-modal" : "enquiry-modal",
                        "open",
                        centreId
                    );
                }

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        'event': isTourModal
                            ? 'optimize.activate_reverse_tour_form'
                            : 'optimize.activate_enq_form'
                    });
                }
            }

            // Set history step
            if (typeof window.history_stepper !== 'undefined') {
                window.history_stepper = settings.historyStep;
            }
        },

        // Close popup modal
        close: function(modalId) {
            var $modal = $(modalId);
            if ($modal.length) {
                $modal.fadeOut(300);
            }
            $('#popup-overlay').fadeOut(300);
            $('body').removeClass('modal-open');
        },

        // Close all modals
        closeAll: function() {
            $('.popup-modal').fadeOut(300, function() {
                // Ensure modal is completely hidden
                $(this).hide();
            });
            $('#popup-overlay').fadeOut(300, function() {
                // Ensure overlay is completely hidden
                $(this).hide();
            });
            $('body').removeClass('modal-open');
        }
    };

    // Make PopupModal globally available
    window.PopupModal = PopupModal;

    // Single entry point for opening the tour modal. Opening the modal alone is
    // not enough: the date picker and time slots are only rendered once
    // initializeTourModal() runs, so every path (button click, #book-tour on
    // load, #book-tour via hashchange) must go through here.
    function openBookTourModal() {
        PopupModal.open('#book-tour-modal', {
            scrollToTop: true,
            analytics: true,
            historyStep: 1
        });

        if (typeof window.initializeTourModal === 'function') {
            window.initializeTourModal();
        }
    }

    function openEnrolmentEnquiryModal() {
        PopupModal.open('#enq-modal', {
            scrollToTop: true,
            analytics: true,
            historyStep: 1
        });

        if (typeof window.initializeEnquiryModal === 'function') {
            window.initializeEnquiryModal();
        }
    }

    // Drop the modal hash without discarding the query string, so campaign
    // parameters on a deeplink survive.
    function clearModalHash() {
        history.replaceState(null, null, window.location.pathname + window.location.search);
    }


    // Book Tour Modal Handlers
    $(document).on('click', 'a.js-book-tour-btn', function(e) {
        // Map pin popup: navigate to centre's tour form URL instead of opening modal.
        if ($(this).closest('#centre-details-modal').length) {
            return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        openBookTourModal();

        return false;
    });

    // Enquiry Modal Handlers
    $(document).on('click', 'a.js-enrolment-enquiry-btn', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        openEnrolmentEnquiryModal();

        return false;
    });

    // Close modal handlers - use more specific selectors
    $(document).on('click', '.js-modal-close-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        PopupModal.closeAll();
        return false;
    });
    
    // Overlay click handler - only close if clicking the overlay itself, not its children
    $(document).on('click', '#popup-overlay', function(e) {
        if (e.target === this) {
            e.preventDefault();
            PopupModal.closeAll();
            return false;
        }
    });

    // ESC key handler
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27) { // ESC key
            PopupModal.closeAll();
        }
    });

    // Override hash-based navigation from old system
    $(window).on('hashchange', function() {
        var hash = window.location.hash;
        if (hash === '#book-tour') {
            openBookTourModal();
            // Remove hash to prevent old system from running
            clearModalHash();
        } else if (hash === '#enrolment-enq') {
            openEnrolmentEnquiryModal();
            // Remove hash to prevent old system from running
            clearModalHash();
        }
    });

    // Check for hash on page load
    if (window.location.hash === '#book-tour') {
        setTimeout(function() {
            openBookTourModal();
            clearModalHash();
        }, 100);
    } else if (window.location.hash === '#enrolment-enq') {
        setTimeout(function() {
            openEnrolmentEnquiryModal();
            clearModalHash();
        }, 100);
    }
});
